// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__33EtN","list":"BalanceDue_list__2MCDj","listRow":"BalanceDue_listRow__2grX2","total":"BalanceDue_total__1s4-G"};